import React from 'react';
import PropTypes from 'prop-types';
import { useSpring, animated } from 'react-spring';
import { useTrackVisibility } from 'react-intersection-observer-hook';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} AnimatedNumberCounterPropTypes
 */

const AnimatedNumberCounter = ({
    toValue = 0,
    onEnd = () => {}
}) => {
    const [ref, { wasEverVisible }] = useTrackVisibility();

    toValue = Number(toValue);

    const { number } = useSpring({
        number: (wasEverVisible ? toValue : 0),
        from: { number: 0 },
        delay: 200,
        config: { mass: 1, tension: 30, friction: 10 },
        onChange: (result) => {
            if (result.value.number === toValue) {
                onEnd();
            }
        }
    });

    const decimalPlaces = toValue % 1 !== 0 ? toValue.toString().split('.')[1].length : 0;

    const output = number.to((val) => val.toFixed(decimalPlaces));

    return (
        <div className='w-min'>
            <animated.div ref={ref}>
                {output}
            </animated.div>
        </div>
    );
};

const amimatedNumberCounterPropTypes = {
    toValue: PropTypes.number.isRequired,
    onEnd: PropTypes.func
};

AnimatedNumberCounter.propTypes = amimatedNumberCounterPropTypes;

export default AnimatedNumberCounter;
